export const testimonials = [
  {
    id: 't001',
    name: '张建国',
    role: '建筑工地领班',
    location: '黑龙江哈尔滨',
    rating: 5,
    content: '干了二十年工地，冬天是最难熬的。自从用了热久久加热马甲，零下二十度也能正常干活。加热均匀，续航够用一整天，已经推荐给整个班组了。',
    imageQuery: 'Portrait of mature Chinese construction foreman in winter work setting%2C professional headshot style%2C soft natural lighting%2C authentic warm expression%2C clean simple background',
  },
  {
    id: 't002',
    name: '李雪梅',
    role: '户外运动爱好者',
    location: '吉林长春',
    rating: 5,
    content: '每年冬天都去长白山滑雪，热久久加热鞋垫真的是救星！以前滑两小时脚就冻僵了，现在可以尽情滑一整天。无线遥控特别方便，强烈推荐给所有雪友。',
    imageQuery: 'Portrait of Chinese female outdoor sports enthusiast in winter setting%2C lifestyle photography%2C bright natural light%2C genuine happy expression%2C clean modern composition',
  },
  {
    id: 't003',
    name: '王建国',
    role: '退休教师',
    location: '辽宁沈阳',
    rating: 5,
    content: '上了年纪特别怕冷，女儿给我买了热久久暖腰贴和暖脚宝。暖腰贴弧度设计特别贴合，暖脚宝毛绒内里很舒服。这个冬天过得比往年都暖和，真心感谢热久久。',
    imageQuery: 'Portrait of elderly Chinese retired teacher at home%2C warm lifestyle photography%2C soft indoor lighting%2C peaceful content expression%2C cozy home atmosphere',
  },
  {
    id: 't004',
    name: '赵明远',
    role: '快递配送员',
    location: '北京',
    rating: 4,
    content: '冬天送快递风大天冷，热久久保暖贴每天必贴。贴在腰背和腹部，一整天暖烘烘的。12小时发热刚好覆盖整个班次，性价比很高。唯一的建议是希望能出更大尺寸的版本。',
    imageQuery: 'Portrait of Chinese delivery worker in winter urban setting%2C documentary style photography%2C natural outdoor lighting%2C authentic professional expression%2C clean modern composition',
  },
];

export const brandStats = [
  { value: '500万+', label: '累计服务用户' },
  { value: '98.6%', label: '用户好评率' },
  { value: '12年', label: '行业深耕经验' },
  { value: '50+', label: '专利技术' },
];

export const brandValues = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '所有产品通过国家质量检测认证，采用安全发热技术，无明火、无辐射，使用更放心。',
  },
  {
    icon: 'ri-temp-hot-line',
    title: '持久恒温',
    description: '先进温控技术确保温度稳定输出，拒绝忽冷忽热，提供始终如一的温暖体验。',
  },
  {
    icon: 'ri-leaf-line',
    title: '环保材料',
    description: '精选环保原材料，产品可降解处理，关注用户温暖的同时也关注地球可持续。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7x24小时客服在线，30天无忧退换，让每一位用户买得放心、用得安心。',
  },
];

export const faqItems = [
  {
    question: '热久久保暖贴可以持续发热多久？',
    answer: '热久久经典保暖贴可持续发热12小时，平均温度53°C；强效保暖贴可持续发热18小时，平均温度58°C。实际发热时长可能因环境温度和使用方式略有差异。',
  },
  {
    question: '保暖贴可以贴身使用吗？',
    answer: '不可以。保暖贴必须贴在内衣外侧，通过衣物隔离。直接接触皮肤可能导致低温烫伤，请务必按照说明书正确使用。',
  },
  {
    question: '热久久加热马甲如何清洗？',
    answer: '加热马甲可取出内置电池和发热组件后手洗或机洗（需放入洗衣袋）。请勿干洗、漂白或拧干。详细清洗说明请参考产品附带的说明书。',
  },
  {
    question: '产品的售后服务政策是怎样的？',
    answer: '电子产品（暖手宝、加热马甲、加热鞋垫等）提供1年质保服务，耗材类产品（保暖贴）享受30天无忧退换。如有任何问题，请联系客服热线或在线客服。',
  },
  {
    question: '如何选择适合自己的保暖产品？',
    answer: '日常通勤推荐经典保暖贴+便携暖手宝组合；户外工作推荐强效保暖贴+加热马甲+加热鞋垫全套方案；居家老人推荐暖腰贴+USB暖脚宝。您也可以联系客服获取个性化推荐。',
  },
  {
    question: '加热产品充电需要多长时间？',
    answer: '便携暖手宝充满约2小时，加热马甲充满约3-4小时，加热鞋垫充满约2.5小时，加热手套充满约2小时。所有产品均支持充电宝供电，方便户外使用。',
  },
];